import Model from '../Model'
import {isNull} from "lodash";

export default class CostPlan extends Model {
    static updateController = new AbortController();

    static async find(packageReference) {
        const data = await Http.get(route('api.v2.commercial-management.cost-plan', {packageReference: packageReference}), {})
        if (data.id) {
            return this.make(data)
        }
        return null
    }

    async reload() {
        let contract = await CostPlan.find(this.id)
        Object.assign(this, contract)
    }

    static async reset(packageReference) {
        const url = route('api.v2.commercial-management.cost-plan.reset', {packageReference: packageReference})
        const o = await Http.post(url, {})
    }

    async save(costPlan = {}) {
        CostPlan.updateController.abort()
        CostPlan.updateController = new AbortController();
        const url = route('api.v2.commercial-management.cost-plan.store', {packageReference: this.packageReference})
        await Http.send('put', url, this, {
            signal: CostPlan.updateController.signal
        }).catch(err => {
        })
    }

    setAttributes(attributes) {
        attributes.sections.forEach((section) => {
            section.tasks.forEach((task) => {
                task.items.forEach((item) => {
                    if (item.buildup) {
                        item.buildup.materials.concat(item.buildup.labour, item.buildup.fixedCosts).forEach((m) => {
                            let component = item.buildup.components.find((i) => i.id === m.componentId);
                            if (component) {
                                m.component = component
                            }
                        })
                    }
                })
            })
        })
        super.setAttributes(attributes)
        this.buildTokens()
    }

    buildTokens() {
        let tokens = [
            this.date,
            this.id,
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }

    disableSnapshots = false

    static buildMapFromItem(item, collector) {
        if (item.buildup) {
            for (let i = 0; i < item.buildup.materials.length; i++) {
                let key = item.buildup.materials[i].name + '|' + item.buildup.materials[i].uom
                if (!collector.materials.has(key)) {
                    collector.materials.set(key, {
                        name: item.buildup.materials[i].name,
                        uom: item.buildup.materials[i].uom,
                        quantity: 0,
                        items: [item]
                    })
                } else {
                    collector.materials.get(key).items.push(item)
                }
                if (item.quantity) {
                    collector.materials.get(key).quantity += parseFloat(item.buildup.materials[i].quantity)
                }
            }
            for (let i = 0; i < item.buildup.labour.length; i++) {
                let key = item.buildup.labour[i].name
                if (!collector.labour.has(key)) {
                    collector.labour.set(key, {
                        name: item.buildup.labour[i].name,
                        used: 0,
                        items: [item]
                    })
                } else {
                    collector.labour.get(key).items.push(item)
                }
                collector.labour.get(key).used++
            }
            for (let i = 0; i < item.buildup.fixedCosts.length; i++) {
                let key = item.buildup.fixedCosts[i].name + '|' + item.buildup.fixedCosts[i].quantity
                if (!collector.fixedCosts.has(key)) {
                    collector.fixedCosts.set(key, {
                        name: item.buildup.fixedCosts[i].name,
                        quantity: item.buildup.fixedCosts[i].quantity,
                        used: 0,
                        items: [item]
                    })
                } else {
                    collector.fixedCosts.get(key).items.push(item)
                }
                collector.fixedCosts.get(key).used++
            }
        }
    }

    static newCollector() {
        return {
            materials: new Map(),
            labour: new Map(),
            fixedCosts: new Map(),
        }
    }

    addSnapshot() {
        if (this.disableSnapshots) return
        let store = this.getSnapshotStore()
        let data = JSON.stringify(this)
        if ((!store.states.length) || (store.states[store.states.length - 1] !== data)) {
            store.states.push(data);
            this.putSnapshotStore(store)
            eventBus.$emit('cost-plan-history-state-updated', {contractedWorks: this, states: store.states})
        }
    }

    clearSnapshots(fromPosition, count = null) {
        const store = this.getSnapshotStore()
        store.states.splice(fromPosition, isNull(count) ? store.states.length - fromPosition : count)
        this.putSnapshotStore(store);
    }

    getSnapshotStore() {
        if (!this.localStateStorage) {
            this.localStateStorage = {}
        }
        if (!this.localStateStorage['cost-plan-history:' + this.id]) {
            this.localStateStorage['cost-plan-history:' + this.id] = {states: []}
        }
        return this.localStateStorage['cost-plan-history:' + this.id]
    }

    putSnapshotStore(store) {
        this.localStateStorage['cost-plan-history:' + this.id] = store;
    }
}
